import React, { PropsWithChildren, useMemo } from 'react'

type UseBody = {
  rowComponent: React.FC<PropsWithChildren>
  itemsInPage: number
  lazy: boolean
  data: Array<any>
}
export const useBody = ({ rowComponent, itemsInPage, lazy, data }: UseBody) => {
  return useMemo(() => {
    const Row = rowComponent
    const displayRows = lazy ? data.slice(0, itemsInPage) : data

    return displayRows.map((rowData, index) => (
      <Row key={index + index} {...rowData} />
    ))
  }, [data, itemsInPage, lazy, rowComponent])
}
